export const data = [
  {
    name: "PASTE",
    text: "“maximus ac. Aliquam imperdiet, est vel fringilla aliquet, odio eros cursus purus, nec porttitor velit enim in libero. Nulla risus lorem, convallis in nisl sed, maximus interdum lectus. Vivamus fringilla, arcu sit amet lobortis posuere,.”",
  },
  {
    name: "BuzzFeed",
    text: "“Praesent vitae odio dui. Ut ac tristique velit. Ut posuere tellus ut nisi consequat, quis porta lectus laoreet. Cras maximus mattis neque a molestie. Phasellus quis sapien pellentesque.”",
  },
  {
    name: "Continental",
    text: "“In malesuada commodo sem quis eleifend. Quisque eget eros at justo fermentum cursus. Sed elit tortor, vestibulum vitae sollicitudin eget, dictum at nisl. Fusce ligula dolor, finibus non enim vel, sodales porttitor tellus.”",
  },
  {
    name: "FastCompany",
    text: "“The result is a richly flavored, super aromatic cup of coffee without the usual silt in the bottom. The press isn’t just for coffee, either—there’s also a tea filter available that isolates tea leaves to prevent oversteeping.”",
  },
  {
    name: "Bonanza",
    text: "“ Vestibulum tincidunt purus est, accumsan tincidunt mauris feugiat vitae. Sed orci risus, suscipit eget tortor nec, rutrum congue neque. Vestibulum ligula massa, tempor at velit sed, imperdiet commodo elit. Mauris eget mollis ipsum. ”",
  },
];
